const state = {
  departmentFilters: [],
  locationFilters: [],
  searchQuery: '',
  selectedFilters: {
    'locationFilters': [],
    'departmentFilters': [],
    'teamFilters': []
  },
  teamFilters: [],
}

const getters = {
  getDepartments: state => {
    return state.departmentFilters
  },
  getLocations: state => {
    return state.locationFilters
  },
  getSearch: state => {
    return state.searchQuery
  },
  getTeams: state => {
    return state.teamFilters
  },
  getSelectedDepartments: state => {
    return state.selectedFilters.departmentFilters
  },
  getSelectedLocations: state => {
    return state.selectedFilters.locationFilters
  },
  getSelectedTeams: state => {
    return state.selectedFilters.teamFilters
  }
}

const mutations = {
  addDepartment (state, data) {
    const { filter } = data
    const { departmentFilters } = state.selectedFilters
    if (!departmentFilters.includes(filter)) {
      state.selectedFilters.departmentFilters.push(filter)
    }
  },
  addLocation (state, data) {
    const { filter } = data
    const { locationFilters } = state.selectedFilters
    if (!locationFilters.includes(filter)) {
      state.selectedFilters.locationFilters.push(filter)
    }
  },
  addTeam (state, data) {
    const { filter } = data
    const { teamFilters } = state.selectedFilters
    if (!teamFilters.includes(filter)) {
      state.selectedFilters.teamFilters.push(filter)
    }
  },
  clearSearch (state) {
    state.searchQuery = ''
  },
  setDepartmentFilters (state, data) {
    state.departmentFilters = data
  },
  setKeywordSearch (state, data) {
    state.searchQuery = data
  },
  setLocationFilters (state, data) {
    state.locationFilters = data
  },
  setTeamFilters (state, data) {
    state.teamFilters = data
  },
  removeDepartment (state, data) {
    const { filter } = data
    const { departmentFilters } = state.selectedFilters
    if (departmentFilters.includes(filter)) {
      state.selectedFilters.departmentFilters.splice(departmentFilters.indexOf(filter), 1)
    }
  },
  removeLocation (state, data) {
    const { filter } = data
    const { locationFilters } = state.selectedFilters
    if (locationFilters.includes(filter)) {
      state.selectedFilters.locationFilters.splice(locationFilters.indexOf(filter), 1)
    }
  },
  removeTeam (state, data) {
    const { filter } = data
    const { teamFilters } = state.selectedFilters
    if (teamFilters.includes(filter)) {
      state.selectedFilters.teamFilters.splice(teamFilters.indexOf(filter), 1)
    }
  },
  reset (state) {
    state.selectedFilters.departmentFilters = []
    state.selectedFilters.locationFilters = []
    state.selectedFilters.teamFilters = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
